import {makeAutoObservable} from 'mobx';
import Slot from './Slot';

export const ROW_TYPE_SIMPLE = 'simple';
export const ROW_TYPE_SUBROW = 'subrow';
export const ROW_TYPE_ALL = 'all';

class Row {

	label;
	type;
	idx;
	group;
	areas; // exterior/interior
	filtertags;
	uri;
	specsheet;
	isExpandedAt;
	viewSpecsheetExpanded;
	parentRow;
	slots;

	constructor(type, idx, data, downloadTypes, hydrateSlots = true) {
		this.type = type;
		this.isExpandedAt = 0;
		this.viewSpecsheetExpanded = false;
		this.slots = [];
		this.idx = idx;
		this.label = data.label;
		this.group = data.group;
		this.areas = data.areas;
		this.uri = data.uri;
		this.specsheet = data.specsheet;
		this.filtertags = data.filtertags || [];
		this.parentRow = data.parentRow || null;
		if (hydrateSlots) {
			const numSlots = data.slots.length;
			this.slots = Array.apply(null, Array(numSlots)).map(() => null);
			for (let x = 0; x < numSlots; x++) {
				this.slots[x] = new Slot(downloadTypes[x], data.slots[x]);
			}
		} else {
			this.slots = data.slots;
		}
		makeAutoObservable(this);
	}

	get selectedForDownload() {
		return this.slots.reduce((rowSelection, slot) => (
			rowSelection.concat(
				slot.getSelectedForDownload(this.uri).map(uri => ({
					uri: uri,
					subproduct: this.label,
					type: slot.type
				}))
			)
		), []);
	}

	get allSelected() {
		for (const slot of this.slots) {
			if (!slot.allSelected) {
				return false;
			}
		}
		return true;
	}

	get isExpanded() {
		return this.slots.filter(s => s.isExpanded).length > 0;
	}

	get isAll() {
		return this.type === ROW_TYPE_ALL;
	}

	get isSimple() {
		return this.type === ROW_TYPE_SIMPLE;
	}

	get isSubrow() {
		return this.type === ROW_TYPE_SUBROW;
	}

	get hasMultipleSpecsheets() {
		return this.slots && this.slots.length > 0 && this.slots[0].downloads && this.slots[0].downloads.length > 1;
	}

	createSubrow(download, expandedAtSlotIdx, downloadTypes) {
		return new Row(ROW_TYPE_SUBROW, -1, {
			isExpandedAt: expandedAtSlotIdx,
			label: download.label,
			areas: this.areas,
			uri: this.uri,
			specsheet: download.specsheet,
			parentRow: this,
			slots: downloadTypes.map((type, idx) =>
				(idx === expandedAtSlotIdx ? new Slot(downloadTypes[idx], [download], false) : new Slot(downloadTypes[idx]))
			),
		}, downloadTypes, false);
	}
}

export default Row;
